import type { IconProps } from './types/types';

const StampedIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.52355 9.14859L10.0343 1.42285L12.3452 1.42287L9.83444 9.14859H7.52355Z"
      fill="#FF672E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57331 16.121L0.999992 11.3462L1.71411 9.14893L8.28742 13.9237L7.57331 16.121Z"
      fill="#FFD600"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2002 18.2213L7.62687 22.9961L5.75732 21.638L12.3306 16.8633L14.2002 18.2213Z"
      fill="#FFB800"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2575 12.5532L20.7683 20.279L18.8988 21.637L16.388 13.9112L18.2575 12.5532Z"
      fill="#FFAA05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1368 6.95117H22.2619L22.976 9.14851H14.8509L14.1368 6.95117Z"
      fill="#FF883B"
    />
  </svg>
);

export default StampedIcon;
